(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('hs-product-grid')) return;

    class HsProductGrid extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hs-track]');
        this.prevBtn = this.querySelector('[data-hs-prev]');
        this.nextBtn = this.querySelector('[data-hs-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.handleScroll = this.updateControls.bind(this);
        this.handlePrev = () => this.go(-1);
        this.handleNext = () => this.go(1);

        if (this.track && this.prevBtn && this.nextBtn) {
          this.prevBtn.addEventListener('click', this.handlePrev);
          this.nextBtn.addEventListener('click', this.handleNext);
          this.track.addEventListener('scroll', this.handleScroll, { passive: true });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.handleScroll);
            this.resizeObserver.observe(this.track);
          }

          this.updateControls();
        }

        if (this.hasAttribute('data-animate') && !this.reduceMotion && 'IntersectionObserver' in window) {
          this.classList.add('hs-grid--reveal-ready');
          this.revealObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.classList.add('hs-grid--revealed');
                  this.revealObserver.disconnect();
                }
              });
            },
            { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
          );
          this.revealObserver.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
        if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.revealObserver) this.revealObserver.disconnect();
      }

      go(direction) {
        if (!this.track) return;
        const firstItem = this.track.querySelector('.hs-grid__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = firstItem ? firstItem.getBoundingClientRect().width + gap : this.track.clientWidth;
        const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));

        this.track.scrollBy({
          left: direction * step * perPage,
          behavior: this.reduceMotion ? 'auto' : 'smooth'
        });
      }

      updateControls() {
        if (!this.track || !this.prevBtn || !this.nextBtn) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const x = this.track.scrollLeft;

        this.prevBtn.disabled = x <= 2;
        this.nextBtn.disabled = x >= max - 2;
        this.classList.toggle('hs-grid--no-overflow', max <= 2);
      }
    }

    customElements.define('hs-product-grid', HsProductGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-size-guide-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__hsSizeGuideBound) return;
    window.__hsSizeGuideBound = true;

    var cache = {};

    function getModal() {
      return document.querySelector('dialog[data-hs-sg-modal]');
    }

    function highlightSize(body, sizeValue) {
      if (!sizeValue) return;
      var wanted = String(sizeValue).trim().toLowerCase();
      body.querySelectorAll('tr[data-size]').forEach(function (row) {
        row.classList.toggle('is-selected', row.getAttribute('data-size') === wanted);
      });
    }

    function showError(body, url) {
      body.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'hs-sg-modal__status';
      p.textContent = 'Таблицата с размери не можа да се зареди. ';
      var a = document.createElement('a');
      a.href = url;
      a.textContent = 'Отвори страницата с таблицата';
      p.appendChild(a);
      body.appendChild(p);
    }

    function render(modal, data, sizeValue) {
      var body = modal.querySelector('[data-hs-sg-body]');
      var title = modal.querySelector('[data-hs-sg-title]');
      body.innerHTML = data.html;
      if (title && data.title) title.textContent = data.title;
      highlightSize(body, sizeValue);
      body.scrollTop = 0;
    }

    function load(url) {
      if (cache[url]) return Promise.resolve(cache[url]);

      return fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Size guide request failed');
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var content = doc.querySelector('[data-hs-size-guide-content]');
          if (!content) throw new Error('Size guide content not found');
          var titleEl = doc.querySelector('[data-hs-size-guide-title]');
          var data = {
            html: content.outerHTML,
            title: titleEl ? titleEl.textContent.trim() : ''
          };
          cache[url] = data;
          return data;
        });
    }

    function withSizeGuideView(href) {
      try {
        var target = new URL(href, window.location.origin);
        target.searchParams.set('view', 'size-guide');
        return target.pathname + target.search;
      } catch (error) {
        return href;
      }
    }

    function open(modal, trigger) {
      var url = withSizeGuideView(trigger.getAttribute('href'));
      var body = modal.querySelector('[data-hs-sg-body]');
      var pageLink = modal.querySelector('[data-hs-sg-page-link]');

      var sizeValue = null;
      var fieldset = trigger.closest('[data-hs-option]');
      if (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        if (checked) sizeValue = checked.value;
      }

      modal.__hsTrigger = trigger;
      if (pageLink) pageLink.setAttribute('href', url);

      if (!cache[url]) {
        body.innerHTML = '<p class="hs-sg-modal__status">Зареждане…</p>';
      }

      modal.showModal();
      document.documentElement.classList.add('hs-sg-is-open');

      var closeBtn = modal.querySelector('[data-hs-sg-close]');
      if (closeBtn) closeBtn.focus();

      load(url)
        .then(function (data) {
          if (modal.open) render(modal, data, sizeValue);
        })
        .catch(function () {
          if (modal.open) showError(body, url);
        });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[data-hs-size-guide]');
      if (trigger) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var modal = getModal();
        if (!modal || typeof modal.showModal !== 'function') return;
        event.preventDefault();
        open(modal, trigger);
        return;
      }

      var closeBtn = event.target.closest('[data-hs-sg-close]');
      if (closeBtn) {
        var dialog = closeBtn.closest('dialog');
        if (dialog && dialog.open) dialog.close();
        return;
      }

      if (event.target.matches && event.target.matches('dialog[data-hs-sg-modal]')) {
        event.target.close();
      }
    });

    document.addEventListener(
      'close',
      function (event) {
        var modal = event.target;
        if (!modal.matches || !modal.matches('dialog[data-hs-sg-modal]')) return;
        document.documentElement.classList.remove('hs-sg-is-open');
        var trigger = modal.__hsTrigger;
        if (trigger && trigger.isConnected) trigger.focus();
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
